import { render, staticRenderFns } from "./GlobalSpecsFormLabourRateRow.vue?vue&type=template&id=4cc097e7&"
import script from "./GlobalSpecsFormLabourRateRow.vue?vue&type=script&lang=js&"
export * from "./GlobalSpecsFormLabourRateRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports